import { localisedValue } from "utils"
const getClientProfileInitialValues = client => {
  if (client) {
    return {
      // Personal Information
      relationshipStrength: client?.relationshipStrength?.toString() || null,
      gender: client?.gender?.toString() || null,
      nationalityId: client?.nationalityId || null,
      maritalStatus: client?.maritalStatus?.toString() || null,
      children: client?.children == 1 ? "true" : client?.children == 0 ? "false" : null,

      // Financial & Professional Details
      companyNameProfiling: client?.companyNameProfiling || "",
      industryId: client?.industryId || null,
      occupation: client?.occupation || null,
      netWorth: [0, client?.netWorth || 0],
      annualRevenueAUM: [0, client?.annualRevenueAUM || 0],
      clientRatingId: client?.clientRatingId?.toString() || null,
      keyShareholderUBO: client?.keyShareholderUBO || "",

      // Purchase Criteria
      budget: [0, client?.budget || 0],
      interestedTypeId: client?.interestedTypeId?.toString() || null,
      area: client?.area?.toString() || null,
      preferredCityIds: client?.preferredCityIds?.map(id => id?.toString()) || null,
      preferredCityRegion: client?.preferredCityIds?.length==1? client?.preferredCityRegion : null,
      preferredLocalityId: client?.preferredCityIds?.length==1? client?.preferredLocalityId?.toString() : null,
      hasExistingProperty: client?.hasExistingProperty == 1 ? "yes" : client?.hasExistingProperty == 0 ? "no" : null,
      intent: client?.intent || null,
      buyingIntentId: client?.buyingIntentId?.toString() || null,
      preferredFinancing: client?.preferredFinancing?.toString() || null,

      // Market Exposure
      politicalExposure: client?.politicalExposure?.toString() || null,
      realEstateIndustryExposure: client?.realEstateIndustryExposure?.toString() || null,
      marketExposure: client?.marketExposure?.toString() || null,

      // Investment Strategy
      investmentStrategy: client?.investmentStrategy || null,
      investmentPeriod: client?.investmentPeriod?.toString() || null,
      targetAnnualIncomePercent: client?.targetAnnualIncomePercent || null,
      targetCapitalReturnPercent: client?.targetCapitalReturnPercent || null,
      targetAllocation: [0, client?.targetAllocation || 0],
      capitalStructure: client?.capitalStructure?.toString() || null,
      assetClass: client?.assetClass || null,
      riskProfile: client?.riskProfile || null,

      // Services Required
      residencyRequirement: client?.residencyRequirement?.toString() || null,
      propertyManagement: client?.propertyManagement?.toString() || null,
      legalTaxServices: client?.legalTaxServices || null,
      travelLogisticsServices: client?.travelLogisticsServices || null,
    }
  }
}

export default getClientProfileInitialValues
